module.exports = __webpack_public_path__ + "img/SunRed.bc644b2d.png";